export default __webpack_public_path__ + "static/media/uv11_kr_alph_a2.d1b32056.mp3";